import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/firestore'
import 'firebase/storage'
import 'firebase/functions'
import Rebase from 're-base'
import { isDev } from '../constants'

const app = firebase.initializeApp({
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_AUTHDOMAIN,
  databaseURL: process.env.REACT_APP_DATABASEURL,
  projectId: process.env.REACT_APP_PROJECTID,
  storageBucket: process.env.REACT_APP_STORAGEBUCKET,
  messagingSenderId: process.env.REACT_APP_MESSAGINGSENDERID,
})

const db = app.firestore()
db.enablePersistence().catch(error => console.error(error))
const base = Rebase.createClass(db)
const storage = firebase.storage()
const functions = firebase.functions()

if (isDev) {
  functions.useEmulator('localhost', 5001)
}

export { app, storage, base, db, functions }
